module.exports = __webpack_public_path__ + "static/media/claimPirze-ziggles.1dc4a86d.png";